import { Button, Grid, IconButton, Paper, Tooltip, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import XLSX from 'xlsx';
// import moment from 'moment';
import * as Gserv from '../services/GatewayService';
import DatasheetView from './DatasheetView';
import {SettingsTwoTone} from '@material-ui/icons';
import Toggle from './Toggle';
import InputField from './InputField';
import ExcelLogo from '../assets/ExcelLogo';
import moment from 'moment';


export default class ETLForm extends Component {
    
    constructor(props) {
        super(props);
        this.initial_state = {
            selectedFile: null,
            page_header: 'Upload Payroll Update File',
            button_caption: "Select Upload File",
            data: null,
            fields: null,
            records_found: null,
            failed_field_check: false,
            failed_data_check: false,
            missing_fields: [],
            missing_data: [],
            error: false,
            error_message: "",
            show_bad_records: false,
            bad_records: [],
            show_spinner: false,
            stage: 'upload',
            rom_codes_missing: false,
            optional_fields: {},
            optional_fields_selected: {
                Branch: false,
                'Job Title': false,
                'P/P': false,
                ROM: false,
                REGION: false
            },
            create_group: false,
            group_name: ''
        }
        this.state=this.initial_state;
        this.required_fields = [
            "Empl. No.",
            "Names",
            "Id Number",
            "REGION"
        ]
        this.datasheetFieldSpecs = [
            { field: 'id', headerName: 'ID Number', width: 120},
            { field: 'employee_number', headerName: 'Empl.#', width: 80},
            { field: 'name', headerName: 'Names', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 110, sortable:false},
            { field: 'store_code', headerName: 'Branch', width: 70, sortable:false},
            { field: 'reports_to_rom', headerName: 'ROM', width: 70, sortable:false},
            { field: 'region', headerName: 'REGION', width: 70, sortable:false},
            { field: 'status', headerName: 'Status', width: 110, sortable:false},
        ]
    }
    
    runChecks = (recordset, optional_fields) => {
        let bad_fields = [];
        let i = 0;
        // for (var i=0; i < recordset.length; i++){
        while (i < recordset.length && bad_fields.length === 0){
            // console.log('recordset[i]:>> ', recordset[i]);
            // console.log('recordset[i].empl:>> ', recordset[i]['Empl. No.']);
            if (!recordset[i]['Empl. No.']||recordset[i]['Empl. No.']===''){bad_fields.push('Empl. No.')}
            if (!recordset[i]['Names']||recordset[i]['Names']===''){bad_fields.push('Names')}
            if (!recordset[i]['Id Number']||recordset[i]['Id Number']===''){bad_fields.push('Id Number')}
            if (!recordset[i]['REGION']||recordset[i]['REGION']===''){bad_fields.push('REGION')}
            for (var key in optional_fields){
                if (!recordset[i][key]||recordset[i][key]===''){
                    optional_fields[key] = 'Missing data';
                }
            }
            i++;
        }

        // console.log('bad_fields :>> ', bad_fields);
        // console.log('optional_fields :>> ', optional_fields);
        return {bad_fields: bad_fields, optional_fields: optional_fields};
    }

    // On file select (from the pop up)
    onFileChange = event => {
        // Update the state
        if (event.target.files[0]){
            this.setState({ selectedFile: event.target.files[0], button_caption:"Checking file...",show_spinner:true});
            const reader = new FileReader();
            reader.onloadend = this.readFile;
            reader.readAsArrayBuffer(event.target.files[0]);
        } else {
            this.setState(this.initial_state);
        }
    };

    readFile = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {type: 'array',cellDates:true});
        const first_sheet_name = workbook.SheetNames[0];
        // console.log('first_sheet_name :>> ', first_sheet_name);
        const mySheet = workbook.Sheets[first_sheet_name];
        const json_array = XLSX.utils.sheet_to_json(mySheet);
        // console.log('json_array[0] :>> ', json_array[0]);
        let myFields = [];
        let optional_fields = {};
        for (var key in json_array[0]){
            myFields.push(key);
            //update optional fields, for later validation
            if (key==='Branch'||key==='P/P'||key==='Job Title'||key==='ROM'||key==='REGION'){optional_fields[key] = 'Available'}
        }

        let missing_fields = [];
        //Check that each required field is here...
        this.required_fields.forEach(field => {
            if (!myFields.includes(field)){
                missing_fields.push(field);
            }
        });

        //Initial check for optional fields
        

        if (missing_fields.length>0){
            this.setState({missing_fields:missing_fields,failed_field_check:true, show_spinner:false});
            return;
        }

        //basic field validation on first line
        // if (!json_array[0].Branch||!json_array[0].Names||!json_array[0].Gender||!json_array[0].Race||!json_array[0]["Job Title"]||!json_array[0].ROM){
        //     this.setState({failed_field_check:true,show_spinner:false});
        //     return;            
        // }

        if (isNaN(json_array[0]["Id Number"])){
            this.setState({missing_fields:"Id Number",failed_field_check:true,show_spinner:false})
            return;
        }

        // if (!moment.isDate(json_array[0].DOE)){
        //     this.setState({missing_fields:"DOE",failed_field_check:true,show_spinner:false})
        //     return;
        // };
    
        // console.log('json_array.length :>> ', json_array.length);
        this.setState({data:json_array, fields: myFields, optional_fields: optional_fields, records_found: json_array.length, button_caption:"Checking data for completeness..."});

        const data_result = this.runChecks(json_array,optional_fields);

        if (data_result.bad_fields.length){
            this.setState({missing_data:data_result.bad_fields,failed_data_check:true, show_spinner:false});
        } else {
            this.setState({optional_fields: data_result.optional_fields, button_caption:"Uploading file..."});
        }

        Gserv.sendCommand('payroll_file_dump',this.props.gwt,{
            form_data_array : this.state.data,
            optional_fields: data_result.optional_fields
        })
        .then(reply => {
            // console.log('upload reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (payroll_file_dump) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",show_spinner:false});
            } else if (reply.statusCode===409){
                console.log('error on return from Gserv (payroll_file_dump) :>> ', reply);
                this.setState({error:true,error_message:"Upload includes one or more duplicate keys. i.e. Either an employee number or an ID number has been duplicated in the upload file.",show_spinner:false});
            } else if (reply.statusCode===406){
                console.log('error on return from Gserv (payroll_file_dump) :>> ', reply);
                this.setState({error:true,error_message:"One or more records have missing fields. Please ensure all lines in the Payroll Update File are fully populated.",show_spinner:false,show_bad_records:true,bad_records:reply.missing_records});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (payroll_file_dump) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",show_spinner:false});
            } else {
                console.log('Ran upload ok...');
                this.setState({button_caption:"Verify ID's and Employee Numbers uploaded",stage:'verify',page_header:'Process Uploaded Data', show_spinner:false });
                // this.fetchUpdateResults();
            }
        });
    }

    verifyNums = () => {
        
        this.setState({button_caption:'Verifying ID and Employee Numbers...', stage:'verifying',show_spinner:true});

        Gserv.sendCommand('verify_uploaded_payroll_file_data',this.props.gwt)
        .then(reply => {
            // console.log('upload reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (verify_uploaded_payroll_file_data) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",show_spinner:false});
            } else if (reply.statusCode===404){
                console.log('error on return from Gserv (verify_uploaded_payroll_file_data) :>> ', reply);

                //Add status field for display
                for (var i=0; i < reply.missing_records.length; i++){
                    if (reply.missing_records[i].employment_terminated){
                        reply.missing_records[i].status = 'TERMINATED';
                    } else {
                        reply.missing_records[i].status = 'NOT FOUND';
                    }
                }

                this.setState({error:true,error_message:"The following employees have ID numbers in the upload batch which do not match an employee record in the TMS, and/or match an employee who has been terminated. Terminated employees must either be reinstated on the TMS, or removed from the upload batch.",show_spinner:false, bad_records: reply.missing_records, show_bad_records:true});
            
            } else if (reply.statusCode===409){
                console.log('error on return from Gserv (verify_uploaded_payroll_file_data) :>> ', reply);
                this.setState({error:true,error_message:"One or more employees in the upload batch have different names in the TMS, or have different employee numbers in the TMS. Please resolve any mismatches before proceeding.",show_spinner:false, bad_records: reply.missing_records, show_bad_records:true});

                //Add status field for display
                for (var j=0; j < reply.missing_records.length; j++){
                    reply.missing_records[j].status = 'EMPL NUM OR NAME MISMATCH';
                }

            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (verify_uploaded_payroll_file_data) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",show_spinner:false});
            } else {
                console.log('Verification successful...');
                this.setState({button_caption:"Update Employee Records",stage:'update_ready', show_spinner:false});
                // this.fetchUpdateResults();
            }
        });
    }

    toggleFieldSelection = (toggleObj) => {
        // console.log('toggleObj :>> ', toggleObj);
        let selected_obj = this.state.optional_fields_selected;
        selected_obj[toggleObj.field] = toggleObj.value;
        this.setState({optional_fields_selected: selected_obj});
    }

    toggleGroupSelection = (toggleObj) => {
        this.setState({create_group: toggleObj.value});
    }

    handleNameUpdate = (updateObj) => {
        this.setState({group_name: updateObj.value});
    }

    fetchUpdateResults = () => {

        if (!this.state.optional_fields_selected.Branch && !this.state.optional_fields_selected['Job Title'] && !this.state.optional_fields_selected['P/P'] && !this.state.optional_fields_selected.ROM && !this.state.optional_fields_selected.REGION && !this.state.create_group ){
            window.alert('No updates have been selected. Please select one or more fields and/or specify an assessment group to create, in order to proceed.');
            return;
        }

        if (this.state.create_group && (!this.state.group_name||this.state.group_name==='')){
            window.alert('Please specify a name for the new Assessment Group to be created.');
            return;
        }

        if (!window.confirm("This function will run the bulk update of employee records based on the uploaded dataset. This cannot be undone! Are you sure you wish to proceed?")){
            return;
        }

        this.setState({button_caption:'Updating employee records...', stage:'updating',show_spinner:true});

        Gserv.sendCommand('update_users_table',this.props.gwt,{
            create_group: this.state.create_group,
            group_name: this.state.group_name,
            optional_fields_selected: this.state.optional_fields_selected
        })
        .then(reply => {
            // console.log('update users table reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (update_users_table) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",show_spinner:false});
            } else if (reply.statusCode===409){
                console.log('error on return from Gserv (update_users_table) :>> ', reply);
                this.setState({error:true,error_message:"An Assessment Group with this name already exists. Please specify a different assessment group name and try again.",show_spinner:false});
            } else if (reply.Result!=="Success"){
                //check
                console.log('error on return from Gserv (update_users_table) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",show_spinner:false});
            } else {
                console.log('Finished users table update.');
                console.log('update users table reply :>> ', reply);
                //need to check here for update integrity issues...
                
                this.setState({button_caption:"Done", show_spinner:false, stage:'done'});
            }
        });
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.bad_records.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.bad_records);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Bulk Upload Conflicts');
            //Write to browser
            XLSX.writeFile(wb,'Conflicts in Bulk Upload File as at ' + dateStr + '.xlsx');
        }
    }

    resetMe = () => {
        this.setState(this.initial_state);
        // document.getElementById("file-upload-obj").value = null;
    }
    
    render() {
        return (
            <Grid
            container
            direction='column'
            justifyContent='center'
            alignContent='center'
            // style={{backgroundColor:'yellow'}}
        >
            
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    width:800
                }}
            >
                <Typography
                    style={{paddingTop:15}}
                >
                    {this.state.page_header}
                </Typography> 
                <hr/>

                {this.state.stage==='upload'&&
                <div>
                    <input
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                        style={{ display: 'none' }}
                        id="file-upload-obj"
                        multiple={false}
                        type="file"
                        onChange={this.onFileChange}
                        disabled={this.state.selectedFile? true : false}
                    />
                    <label htmlFor="file-upload-obj">
                        
                        {this.state.show_spinner&&
                        <span>
                            <SettingsTwoTone className='icn-spinner'/>&nbsp;
                        </span>}

                        <Button 
                            variant="contained"
                            color='primary'
                            component="span"
                            disabled={(this.state.selectedFile? true : false)}
                            style={{marginBottom:15}}
                        >
                            {this.state.button_caption}
                        </Button>
                    </label>

                    {this.state.selectedFile&&
                    <Typography>
                        {this.state.selectedFile.name}
                    </Typography>}
                </div>}
                
                {(this.state.stage==='verify'||this.state.stage==='verifying')&&
                <div> 

                    
                    {this.state.show_spinner&&
                    <span>
                        <SettingsTwoTone className='icn-spinner'/>&nbsp;
                    </span>}     

                    <Button 
                        variant="contained"
                        color='primary'
                        component="span"
                        disabled={this.state.stage==='verifying'}
                        style={{marginBottom:15}}
                        onClick={this.verifyNums}
                    >
                        {this.state.button_caption}
                    </Button>

                </div>}

                {(this.state.stage==='update_ready'||this.state.stage==='updating')&&        
                <div>

                    <Typography color='primary' style={{marginBottom:15}}>
                        Please indicate which fields you would like to update from the uploaded dataset:
                    </Typography>

                    <Grid container direction={'column'} alignItems={'center'} justifyContent={'center'}>
                        <table><tbody>
                        <tr>
                            <td><Typography>Branch:</Typography></td>
                            <td>
                            <Toggle 
                                fieldMap={{
                                    field: "Branch",
                                    headerName: "",
                                    f_inputType:'toggle',
                                    f_true_tag:'Yes',
                                    f_false_tag:'No',
                                    f_show:true
                                }}
                                setField={this.toggleFieldSelection}
                                // editRecord={this.state.current_record}
                                disabled={this.state.stage==='updating'||this.state.optional_fields["Branch"]!=='Available'}
                            />
                            </td>
                            <td>
                            {this.state.optional_fields["Branch"]!=='Available'&&
                            <Typography color='secondary'>
                                {this.state.optional_fields["Branch"]}
                            </Typography>}
                            </td>
                        </tr>
                        <tr>
                            <td><Typography>Job Title:</Typography></td>
                            <td>
                            <Toggle 
                                fieldMap={{
                                    field: "Job Title",
                                    headerName: "",
                                    f_inputType:'toggle',
                                    f_true_tag:'Yes',
                                    f_false_tag:'No',
                                    f_show:true
                                }}
                                setField={this.toggleFieldSelection}
                                // editRecord={this.state.current_record}
                                disabled={this.state.stage==='updating'||this.state.optional_fields["Job Title"]!=='Available'}
                            />
                            </td>
                            <td>
                            {this.state.optional_fields["Job Title"]!=='Available'&&
                            <Typography color='secondary'>
                                {this.state.optional_fields["Job Title"]}
                            </Typography>}
                            </td>
                        </tr>
                        <tr>
                            <td><Typography>P/P:</Typography></td>
                            <td>
                            <Toggle 
                                fieldMap={{
                                    field: "P/P",
                                    headerName: "",
                                    f_inputType:'toggle',
                                    f_true_tag:'Yes',
                                    f_false_tag:'No',
                                    f_show:true
                                }}
                                setField={this.toggleFieldSelection}
                                // editRecord={this.state.current_record}
                                disabled={this.state.stage==='updating'||this.state.optional_fields["P/P"]!=='Available'}
                            />
                            </td>
                            <td>
                            {this.state.optional_fields["P/P"]!=='Available'&&
                            <Typography color='secondary'>
                                {this.state.optional_fields["P/P"]}
                            </Typography>}
                            </td>
                        </tr>
                        <tr>
                            <td><Typography>ROM:</Typography></td>
                            <td>
                            <Toggle 
                                fieldMap={{
                                    field: "ROM",
                                    headerName: "",
                                    f_inputType:'toggle',
                                    f_true_tag:'Yes',
                                    f_false_tag:'No',
                                    f_show:true
                                }}
                                setField={this.toggleFieldSelection}
                                // editRecord={this.state.current_record}
                                disabled={this.state.stage==='updating'||this.state.optional_fields["ROM"]!=='Available'}
                            />
                            </td>
                            <td>
                            {this.state.optional_fields["ROM"]!=='Available'&&
                            <Typography color='secondary'>
                                {this.state.optional_fields["ROM"]}
                            </Typography>}
                            </td>
                        </tr>
                        <tr>
                            <td><Typography>REGION:</Typography></td>
                            <td>
                            <Toggle 
                                fieldMap={{
                                    field: "REGION",
                                    headerName: "",
                                    f_inputType:'toggle',
                                    f_true_tag:'Yes',
                                    f_false_tag:'No',
                                    f_show:true
                                }}
                                setField={this.toggleFieldSelection}
                                // editRecord={this.state.current_record}
                                disabled={this.state.stage==='updating'||this.state.optional_fields["REGION"]!=='Available'}
                            />
                            </td>
                            <td>
                            {this.state.optional_fields["REGION"]!=='Available'&&
                            <Typography color='secondary'>
                                {this.state.optional_fields["REGION"]}
                            </Typography>}
                            </td>
                        </tr>
                        </tbody></table>
                    </Grid>

                    <hr/>    

                    <Typography color='primary' style={{marginBottom:15}}>
                        Would you like to create an Assessment Group?
                    </Typography>
                    
                    <Grid container alignItems={'center'} justifyContent={'center'} style={{marginBottom:10}}>
                        <Grid item>
                            <Toggle 
                                fieldMap={{
                                    field: "assessment_group_selected",
                                    headerName: "",
                                    f_inputType:'toggle',
                                    f_true_tag:'Yes',
                                    f_false_tag:'No',
                                    f_show:true
                                }}
                                setField={this.toggleGroupSelection}
                                // editRecord={this.state.current_record}
                                disabled={this.state.stage==='updating'}
                            />
                        </Grid>
                        &nbsp;&nbsp;
                        <Grid item>
                            <div style={{width:200}}>        
                            <InputField 
                                fieldMap={{
                                    field: "group_name",
                                    headerName: "Assessment Group Name",
                                    f_inputType:'text',
                                    f_show:true,
                                    f_required:true,
                                    f_minLength: 3,
                                    f_maxLength: 200
                                }}
                                
                                setField={this.handleNameUpdate}
                                // editRecord={this.state.current_record}
                                disabled={this.state.stage==='updating'||!this.state.create_group}
                            />
                            </div>
                        </Grid>
                    </Grid>
                    
                    <hr/>

                    {this.state.show_spinner&&
                    <span>
                        <SettingsTwoTone className='icn-spinner'/>&nbsp;
                    </span>}       
                
                    <Button 
                        variant="contained"
                        color='primary'
                        component="span"
                        disabled={this.state.stage==='updating'}
                        style={{marginBottom:15}}
                        onClick={this.fetchUpdateResults}
                    >
                        {this.state.button_caption}
                    </Button>
                </div>}

                {this.state.stage==='done'&&    
                <Typography color='primary' style={{marginBottom:15}}>Bulk update completed successfully.<br/><br/></Typography>}

            </Paper>
            </Grid>

            {this.state.failed_field_check&&        
            <Grid item>
                <Typography color='secondary' style={{Width:800,maxWidth:800, textAlign:'center'}}>
                    There seem to be one or more missing or invalid fields in the uploaded file.<br/> {this.state.missing_fields? "[Can't find the following field(s): " + this.state.missing_fields.toString() + "]" : ""}
                </Typography>
                <Button color='primary' variant='outlined' onClick={this.resetMe}>Retry</Button>
            </Grid>}
           
            {this.state.failed_data_check&&        
            <Grid item>
                <Typography color='secondary' style={{Width:800,maxWidth:800, textAlign:'center'}}>
                    There seems to be missing data for one or more employees in the uploaded file.<br/> {this.state.missing_fields? "[Missing data in the following column: " + this.state.missing_data.toString() + "]" : ""}
                </Typography>
                <Button color='primary' variant='outlined' onClick={this.resetMe}>Retry</Button>
            </Grid>}

            <Grid item>
                <Typography color='secondary' style={{Width:800,maxWidth:800, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

            {this.state.show_bad_records&&    
            <div>
                <div style={{textAlign:'right',paddingRight:20, width:'100%'}}>
                    <Tooltip title="Export to Excel">
                    <span>
                        <IconButton 
                            aria-label='Export to Excel'
                            onClick={this.exportMe}
                            disabled={this.state.bad_records.length===0}
                        >
                            <ExcelLogo />
                        </IconButton>
                    </span>
                    </Tooltip>
                </div>
                
                <hr/>
    
                <DatasheetView 
                        dataset={this.state.bad_records}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={false}
                        edit={false}
                        handleDelete={null}
                        handleEdit={null}
                        loading={this.state.querying}
                        deleteHeaderName={'Delete'}
                        pagesize={8}
                />
            </div>}

            {this.state.rom_codes_missing&&
            <Typography>
                
            </Typography>}


            {this.state.form_view&&
            <Paper
                elevation={3}
            >
                <form onSubmit={this.processForm}>
                    <br/>
                    <Grid 
                        container 
                        direction='column'
                        alignItems='baseline'
                        justifyContent='flex-start'
                        spacing={1}
                        style={{width:'70%', marginLeft:'30%' }}
                    >

                        <br/>
                    </Grid>
                    <Button 
                        color='primary'
                        variant='outlined'
                        // disabled={!this.state.primary_button_enabled}
                        type='submit'
                        style={{marginTop:'20px', marginBottom: '20px'}}
                    >
                        {this.state.primary_button_text}
                    </Button>
                    <Button 
                        type='button'
                        variant='outlined'
                        // disabled={this.state.writing}
                        onClick={()=>this.setState({form_view:false})}
                        style={{marginTop:'20px', marginBottom: '20px'}}
                    >
                        Cancel
                    </Button>
                </form>
            </Paper>}

        </Grid>
        );
    }

}